export default "__VITE_ASSET__cb6f0a22__"